import { Component, OnInit } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { DataIoService } from '../../../services/data-io.service';
import { IconBarService } from '../../../services/icon-bar.service';
import { NavBarService } from '../../../services/nav-bar.service';
import { MenuNode } from '../../../classes/MenuNode';
import { TimeFrameManager } from '../../../classes/TimeFrameManager';
import { TimeFrame } from '../../../classes/TimeFrame';
import { BaseSensor } from '../../../classes/BaseSensor';

@Component({
  selector: 'app-quickveto',
  templateUrl: './quickveto.component.html',
  styleUrls: ['./quickveto.component.scss']
})
export class QuickvetoComponent implements OnInit {
	mode:string=undefined;
	sensor:BaseSensor=undefined;
	hasControl:boolean=false;
	constructor(
		private menuService:MenuService,
		private ioService:DataIoService,
		private iconbar:IconBarService,
		private navBar:NavBarService
	) {
		if(this.ioService){
			console.log("IOService exists");
		}
		if(this.ioService.deviceInfo()){
			console.log("deviceinfo exists");
		}

	}
	s():string{
		return '';
	}
	currentTimeframe=undefined;
	witterungsgefuehrt=false;
	b():string{
		if(this.hasControl && this.mode == 'heating'){
			return 'on';
		}
		if(this.witterungsgefuehrt){
			
			if(this.currentTimeframe){
				return 'off';
			}else{
				return 'on';
			}
		}

		if(this.ioService.getConfiguration().simulatorConfig.isStandalone()){
			if(this.currentTimeframe != undefined){
				return 'off';
			}
		}
		return this.sensor.getCurrentValue()+"";
	}
	unit():string{
		if(this.hasControl && this.mode == 'heating'){
			return '';
		}
		if(this.witterungsgefuehrt){
			return '';
		}
		if(this.ioService.getConfiguration().simulatorConfig.isStandalone()){
			if(this.currentTimeframe != undefined){
				return '';
			}
		}
		return this.sensor.getRawUnit();
	}
	hasScale():boolean{
		if(this.hasControl){
			return false;
		}
		if(this.mode == 'heating'){
			if(this.ioService == undefined){
				console.warn('ioService is undefined.');
			}
			if(this.ioService.deviceInfo() == undefined){
				console.warn('ioService.deviceInfo() is undefined.');
			}
			
			return (this.ioService.deviceInfo().getDefaultZone().getRawValue('heatingmode')=='ENUM_HEATING_MODE_TIMECONTROLLED');
		}
		return false;
	}
	scaleType():string{
		return 'timeline';
	}
	getScaleElements():Array<number>{
		if(!this.hasScale()){
			return undefined;
		}
		let now = new Date();
		let day = now.getDay();
		day--;
		if(day == -1){
			day = 6;
		}
		let scale = this.ioService.deviceInfo().getDefaultZone().getTimeFrameManager('heating').getScale(day,47);
		let tf = this.ioService.getDeviceInfo().tempFrame;
		if(tf){
			let blinkMin = Math.round(48*tf.getStartRelative());
			let blinkMax = Math.round(48*tf.getEndRelative());
			console.log("Blinking from " + blinkMin+ " to " + blinkMax);
			if(blinkMin <= blinkMax){
				for(let i = blinkMin; i < blinkMax; i++){
					scale[i]=2;
				}
			}
		}
		return scale;
	}	
	
	init():void{
		this.navBar.disableAll();
		console.log("Init: Basic/Dash");
		this.mode = this.ioService.deviceInfo().getRawValue('ai_mode');
		if(this.mode == 'heating'){
			let now = new Date();
			let day = now.getDay();
			day--;
			if(day == -1){
				day = 6;
			}
			let tfm :TimeFrameManager = this.ioService.deviceInfo().getDefaultZone().getTimeFrameManager('heating');
			let tf = tfm.getTimeFrame(day,now);
			this.currentTimeframe = tf;
			let begin = new Date();
			let end = new Date();
			end.setHours(23);
			end.setMinutes(59);
			

			if(tf === null){
				this.sensor = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp_wunsch');
				for(let frame of tfm.getTimeFrames(day)){
					if(
						frame.toNumber(frame.getBegin()) < frame.toNumber(end) && 
					   	frame.toNumber(frame.getBegin()) > frame.toNumber(now)
					   )
					   {
					   		console.log("Found frame");
					   		console.log("Frame.getBegin():"+frame.getBegin());
					   		console.log("Frame.getEnd():"+frame.getEnd());
					   		end = new Date(frame.getBegin().getTime());
					   }
				}
			}else{
				end = tf.getEnd();
				this.sensor = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp_absenkwunsch');
			}
			this.ioService.getDeviceInfo().tempFrame = new TimeFrame();
			this.ioService.getDeviceInfo().tempFrame.setBegin(begin);
			this.ioService.getDeviceInfo().tempFrame.setEnd(end);
				
			console.log("Blink begin: "+begin);
			console.log("Blink end: "+end);
			
			if(this.hasControl){
				this.menuService.disableButton('up');
				this.menuService.disableButton('down');			
				this.menuService.disableButton('slider');
			}
		}
		if(this.mode == 'dhw'){
			this.sensor = this.ioService.deviceInfo().getScale('d006');
			if(this.hasControl){
				this.menuService.undisableButton('up');
				this.menuService.undisableButton('down');
				this.menuService.undisableButton('slider');
			}
		}

	}
	eventSubscription : any = undefined;


	ngOnInit() {
		this.hasControl = this.ioService.getConfiguration().simulatorConfig.hasControl();
		this.witterungsgefuehrt = this.ioService.getConfiguration().simulatorConfig.witterungsgefuehrt();
		this.init();
		this.iconbar.enable();
		this.iconbar.evaluate();
		console.log("OnInit on BaseDisplay called on Node: "+this.menuService.getCurrentNode().getIdentifier());
		this.eventSubscription = this.ioService.inputs.events$.subscribe( 
			(evt) => {
				if(['heating','dhw'].includes(evt)){
					this.init();
					return;
				}
				
				if(evt == 'back'){
					this.ioService.deviceInfo().tempFrame = undefined;
					this.menuService.goto('dashboard');
					return;
				}
				if(['up','down'].includes(evt)){
					if(this.mode == 'dhw'){
						this.menuService.goto('quickset-desired-dhw');
						return;
					}
					if(this.mode == 'heating'){
						this.menuService.goto('quickveto');

						return;	
					}
					let heatingMode = this.ioService.deviceInfo().getDefaultZone().getRawValue('heatingmode');
					switch(heatingMode){
						case 'ENUM_HEATING_MODE_OFF':{
							return;
						}
						case 'ENUM_HEATING_MODE_MANUAL':{
							this.menuService.goto('desired-temperature');
							return;
						}
						case 'ENUM_HEATING_MODE_TIMECONTROLLED':{
							this.menuService.goto('quickset-desired-temperature');
							return;	
						}
						
					}
					
					return;
				}
				if(evt == 'menu'){
					console.log("Entering Waterpressure-Widget");
					let waterPressureNode = this.menuService.getCurrentNode().findFromRoot('waterpressure_widget');
					this.menuService.goto(waterPressureNode);
					return;
				}
				if(evt == 'confirm'){
					this.menuService.goto('dashboard');
					return;
				}
			}
		);
	}


	ngOnDestroy(){
		if(this.eventSubscription){
			this.eventSubscription.unsubscribe();
		}
		console.log("OnDestroy on BaseDisplay called on Node: "+this.menuService.getCurrentNode().getIdentifier());
	}
}
